module.exports = __webpack_public_path__ + "media/Shapes/Shape2-f5935611.svg";